var _g, _g2, _g3, _ellipse, _path, _g4, _ellipse2, _path2, _g5, _ellipse3, _path3, _g6, _ellipse4, _path4, _g7, _ellipse5, _path5, _g8, _ellipse6, _path6, _g9, _ellipse7, _path7, _g0, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 66 66",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m58.2 24.9v-10.4c0-.7-.5-1.2-1.2-1.2h-2.2v2.2l-5.4-3.7 5.4-3.7v2.2h3.2c1.8 0 3.2 1.4 3.2 3.2v11.4",
    fill: "#34cba0"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m58.2 24.9v-10.4c0-.7-.5-1.2-1.2-1.2h-2.2v2.2l-5.4-3.7 5.4-3.7v2.2h3.2c1.8 0 3.2 1.4 3.2 3.2v11.4",
    style: {
      fill: "none",
      stroke: "#151f81",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 1.5
    }
  }))))))), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m7.8 24.9v-10.4c0-.7.5-1.2 1.2-1.2h2.2v2.2l5.4-3.7-5.4-3.7v2.2h-3.3c-1.8 0-3.2 1.4-3.2 3.2v11.4",
    fill: "#34cba0"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m7.8 24.9v-10.4c0-.7.5-1.2 1.2-1.2h2.2v2.2l5.4-3.7-5.4-3.7v2.2h-3.3c-1.8 0-3.2 1.4-3.2 3.2v11.4",
    style: {
      fill: "none",
      stroke: "#151f81",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 1.5
    }
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#34cba0"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.8,
    cy: 50,
    rx: 2.6,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.8 64.3c1.4 0 2.6-.9 2.9-2.3.1-.6.2-1.2.2-1.8 0-3.4-2.7-4.1-6.1-4.1s-6.1.7-6.1 4.1c0 .6.1 1.2.2 1.8.3 1.3 1.5 2.3 2.9 2.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "#151f81",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 1.5
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.8,
    cy: 50,
    rx: 2.6,
    ry: 2.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.8 64.3c1.4 0 2.6-.9 2.9-2.3.1-.6.2-1.2.2-1.8 0-3.4-2.7-4.1-6.1-4.1s-6.1.7-6.1 4.1c0 .6.1 1.2.2 1.8.3 1.3 1.5 2.3 2.9 2.3z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#2aabf5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.2,
    cy: 30.7,
    rx: 2.6,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.2 45c1.4 0 2.6-.9 2.9-2.3.1-.6.2-1.2.2-1.8 0-3.4-2.7-4.1-6.1-4.1s-6.1.7-6.1 4.1c0 .6.1 1.2.2 1.8.3 1.3 1.5 2.3 2.9 2.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "#151f81",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 1.5
    }
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.2,
    cy: 30.7,
    rx: 2.6,
    ry: 2.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.2 45c1.4 0 2.6-.9 2.9-2.3.1-.6.2-1.2.2-1.8 0-3.4-2.7-4.1-6.1-4.1s-6.1.7-6.1 4.1c0 .6.1 1.2.2 1.8.3 1.3 1.5 2.3 2.9 2.3z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#f3877e"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33,
    cy: 30.7,
    rx: 2.6,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 45c1.4 0 2.6-.9 2.9-2.3.1-.6.2-1.2.2-1.8 0-3.4-2.7-4.1-6.1-4.1s-6.1.7-6.1 4.1c0 .6.1 1.2.2 1.8.3 1.3 1.5 2.3 2.9 2.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "#151f81",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 1.5
    }
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33,
    cy: 30.7,
    rx: 2.6,
    ry: 2.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m36 45c1.4 0 2.6-.9 2.9-2.3.1-.6.2-1.2.2-1.8 0-3.4-2.7-4.1-6.1-4.1s-6.1.7-6.1 4.1c0 .6.1 1.2.2 1.8.3 1.3 1.5 2.3 2.9 2.3z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffc408"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.8,
    cy: 30.7,
    rx: 2.6,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.8 45c1.4 0 2.6-.9 2.9-2.3.1-.6.2-1.2.2-1.8 0-3.4-2.7-4.1-6.1-4.1s-6.1.7-6.1 4.1c0 .6.1 1.2.2 1.8.3 1.3 1.5 2.3 2.9 2.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "#151f81",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 1.5
    }
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.8,
    cy: 30.7,
    rx: 2.6,
    ry: 2.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m53.8 45c1.4 0 2.6-.9 2.9-2.3.1-.6.2-1.2.2-1.8 0-3.4-2.7-4.1-6.1-4.1s-6.1.7-6.1 4.1c0 .6.1 1.2.2 1.8.3 1.3 1.5 2.3 2.9 2.3z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffc408"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.6,
    cy: 50,
    rx: 2.6,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.6 64.3c1.4 0 2.6-.9 2.9-2.3.1-.6.2-1.2.2-1.8 0-3.4-2.7-4.1-6.1-4.1s-6.1.7-6.1 4.1c0 .6.1 1.2.2 1.8.3 1.3 1.5 2.3 2.9 2.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "#151f81",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 1.5
    }
  }, _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.6,
    cy: 50,
    rx: 2.6,
    ry: 2.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m27.6 64.3c1.4 0 2.6-.9 2.9-2.3.1-.6.2-1.2.2-1.8 0-3.4-2.7-4.1-6.1-4.1s-6.1.7-6.1 4.1c0 .6.1 1.2.2 1.8.3 1.3 1.5 2.3 2.9 2.3z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#2aabf5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.4,
    cy: 50,
    rx: 2.6,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.4 64.3c1.4 0 2.6-.9 2.9-2.3.1-.6.2-1.2.2-1.8 0-3.4-2.7-4.1-6.1-4.1s-6.1.7-6.1 4.1c0 .6.1 1.2.2 1.8.3 1.3 1.5 2.3 2.9 2.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "#151f81",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 1.5
    }
  }, _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.4,
    cy: 50,
    rx: 2.6,
    ry: 2.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m44.4 64.3c1.4 0 2.6-.9 2.9-2.3.1-.6.2-1.2.2-1.8 0-3.4-2.7-4.1-6.1-4.1s-6.1.7-6.1 4.1c0 .6.1 1.2.2 1.8.3 1.3 1.5 2.3 2.9 2.3z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#f3877e"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.2,
    cy: 50,
    rx: 2.6,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.2 64.3c1.4 0 2.6-.9 2.9-2.3.1-.6.2-1.2.2-1.8 0-3.4-2.7-4.1-6.1-4.1s-6.1.7-6.1 4.1c0 .6.1 1.2.2 1.8.3 1.3 1.5 2.3 2.9 2.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "#151f81",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 1.5
    }
  }, _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.2,
    cy: 50,
    rx: 2.6,
    ry: 2.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m61.2 64.3c1.4 0 2.6-.9 2.9-2.3.1-.6.2-1.2.2-1.8 0-3.4-2.7-4.1-6.1-4.1s-6.1.7-6.1 4.1c0 .6.1 1.2.2 1.8.3 1.3 1.5 2.3 2.9 2.3z"
  })))))))), /*#__PURE__*/React.createElement("g", null, _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m42 15.6c-.2.8-.5 1.6-1 2.3-.1.2-.1.5 0 .7l.9 1.2c.2.3.1.6-.1.8l-1.4 1.4c-.2.2-.6.2-.8.1l-1.2-.9c-.2-.1-.5-.1-.7 0-.7.4-1.5.8-2.3 1-.2.1-.4.3-.5.5l-.3 1.5c-.1.3-.3.5-.6.5h-2c-.3 0-.6-.2-.6-.5l-.3-1.5c0-.2-.2-.4-.5-.5-.8-.2-1.6-.5-2.3-1-.2-.1-.5-.1-.7 0l-1.2.9c-.3.2-.6.1-.8-.1l-1.4-1.4c-.2-.2-.2-.6-.1-.8l.9-1.2c.1-.2.1-.5 0-.7-.4-.7-.8-1.5-1-2.3-.1-.2-.3-.4-.5-.5l-1.5-.2c-.3-.1-.5-.3-.5-.6v-2c0-.3.2-.6.5-.6l1.5-.3c.2 0 .4-.2.5-.5.2-.8.5-1.6 1-2.3.1-.2.1-.5 0-.7l-.9-1.2c-.2-.3-.1-.6.1-.8l1.4-1.4c.2-.2.6-.2.8-.1l1.2.9c.2.1.5.1.7 0 .7-.4 1.5-.8 2.3-1 .2-.1.4-.3.5-.5l.3-1.5c0-.3.3-.5.6-.5h2c.3 0 .6.2.6.5l.3 1.5c0 .2.2.4.5.5.8.2 1.6.5 2.3 1 .2.1.5.1.7 0l1.2-.9c.3-.2.6-.1.8.1l1.4 1.4c.2.2.2.6.1.8l-.9 1.2c-.1.2-.1.5 0 .7.4.7.8 1.5 1 2.3.1.2.3.4.5.5l1.5.3c.3.1.5.3.5.6v2c0 .3-.2.6-.5.6l-1.5.3c-.3 0-.5.2-.5.4z",
    fill: "#d7e8ff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 13.3,
    fill: "#fff",
    r: 3.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m42 15.6c-.2.8-.5 1.6-1 2.3-.1.2-.1.5 0 .7l.9 1.2c.2.3.1.6-.1.8l-1.4 1.4c-.2.2-.6.2-.8.1l-1.2-.9c-.2-.1-.5-.1-.7 0-.7.4-1.5.8-2.3 1-.2.1-.4.3-.5.5l-.3 1.5c-.1.3-.3.5-.6.5h-2c-.3 0-.6-.2-.6-.5l-.3-1.5c0-.2-.2-.4-.5-.5-.8-.2-1.6-.5-2.3-1-.2-.1-.5-.1-.7 0l-1.2.9c-.3.2-.6.1-.8-.1l-1.4-1.4c-.2-.2-.2-.6-.1-.8l.9-1.2c.1-.2.1-.5 0-.7-.4-.7-.8-1.5-1-2.3-.1-.2-.3-.4-.5-.5l-1.5-.2c-.3-.1-.5-.3-.5-.6v-2c0-.3.2-.6.5-.6l1.5-.3c.2 0 .4-.2.5-.5.2-.8.5-1.6 1-2.3.1-.2.1-.5 0-.7l-.9-1.2c-.2-.3-.1-.6.1-.8l1.4-1.4c.2-.2.6-.2.8-.1l1.2.9c.2.1.5.1.7 0 .7-.4 1.5-.8 2.3-1 .2-.1.4-.3.5-.5l.3-1.5c0-.3.3-.5.6-.5h2c.3 0 .6.2.6.5l.3 1.5c0 .2.2.4.5.5.8.2 1.6.5 2.3 1 .2.1.5.1.7 0l1.2-.9c.3-.2.6-.1.8.1l1.4 1.4c.2.2.2.6.1.8l-.9 1.2c-.1.2-.1.5 0 .7.4.7.8 1.5 1 2.3.1.2.3.4.5.5l1.5.3c.3.1.5.3.5.6v2c0 .3-.2.6-.5.6l-1.5.3c-.3 0-.5.2-.5.4z",
    style: {
      fill: "none",
      stroke: "#151f81",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 1.5
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 13.3,
    r: 3.7,
    style: {
      fill: "none",
      stroke: "#151f81",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 1.5
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.ea82bb6a6c626fa68d9ee590aebfd623.svg";
export { ForwardRef as ReactComponent };